import { render, staticRenderFns } from "./TheSelectIvg.vue?vue&type=template&id=60af1b4c&scoped=true"
import script from "./TheSelectIvg.vue?vue&type=script&lang=ts"
export * from "./TheSelectIvg.vue?vue&type=script&lang=ts"
import style0 from "./TheSelectIvg.vue?vue&type=style&index=0&id=60af1b4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60af1b4c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CoreSelectTheSelect: require('/usr/src/nuxt-app/components/core/select/TheSelect.vue').default})
